import { styled, Typography } from '@mui/material';

export const ListFieldContainer = styled('fieldset', {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: theme.shape.borderRadius,
  padding: '18.5px 14px',
  color: theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',

  ...(error && {
    border: `1px solid ${theme.palette.error.main}`,
  }),
}));

export const ListFieldLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  maxWidth: 'max-content',
  fontSize: 'calc(1rem * 0.75)',
  padding: '0px 6px',
  marginLeft: -6,
  color: theme.palette.text.secondary,

  ...(error && {
    color: theme.palette.error.main,
  }),
}));
